export default function emptyDataFormat(value, defaultValue = null) {
  let result = defaultValue == null ? '-' : defaultValue

  if (value != undefined && value != null && value != '') {
    return value
  }

  return result
}
